String.prototype.capitalize = function(): string {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

export default String;
